

/// <reference path="CoreEntityUpdatedBy.ts" />

// Generated class ReplicaConfig_ManagedObject

class ReplicaConfig_ManagedObject extends CoreEntityUpdatedBy
{

    // Property: tags
    set tags(value:string) {
        this.setValueForKey(value, 'tags');
    }
    get tags():string {
        return this.valueForKey('tags');
    }
    set tagsPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'tags');
    }
    get tagsPrimitiveValue():string {
        return this.primitiveValueForKey('tags');
    }

    // Property: targetSchema
    set targetSchema(value:string) {
        this.setValueForKey(value, 'targetSchema');
    }
    get targetSchema():string {
        return this.valueForKey('targetSchema');
    }
    set targetSchemaPrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'targetSchema');
    }
    get targetSchemaPrimitiveValue():string {
        return this.primitiveValueForKey('targetSchema');
    }

    // Property: type
    set type(value:number) {
        this.setValueForKey(value, 'type');
    }
    get type():number {
        return this.valueForKey('type');
    }
    set typePrimitiveValue(value:number) {
        this.setPrimitiveValueForKey(value, 'type');
    }
    get typePrimitiveValue():number {
        return this.primitiveValueForKey('type');
    }
}
